﻿const emptyPage = (page = 1, pageSize = 10) => ({
  data: [],
  pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: page,
    pageSize,
  },
  uniqueValues: {},
});

export const fetchForms = async (params = {}) => {
  return emptyPage(params.page || 1, params.pageSize || 10);
};

export const createForm = async () => {
  throw new Error("Forms endpoint is not ready yet");
};

export const updateForm = async () => {
  throw new Error("Forms endpoint is not ready yet");
};

export const deleteForm = async () => {
  throw new Error("Forms endpoint is not ready yet");
};

export const getAvailableDocuments = async () => [];

